module.exports = __webpack_public_path__ + "static/media/02.6e9a39f5.webm";